import { __assign, __extends, __rest } from "tslib";
import React from "react";
import { View, Platform } from "react-native";
import PnmacAvatar from "../Avatar";
import PnmacBubble from "../Bubble";
import PnmacDay from "../Day";
import { isSameUser, isSameDay } from "../utils";
import PropTypes from "prop-types";
import styles from "./PnmacMessage.styles.js";
var PnmacMessage = /** @class */function (_super) {
  __extends(PnmacMessage, _super);
  function PnmacMessage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacMessage.prototype.getInnerComponentProps = function () {
    var _a = this.props,
      containerStyle = _a.containerStyle,
      props = __rest(_a, ["containerStyle"]);
    return __assign(__assign({}, props), {
      isSameUser: isSameUser,
      isSameDay: isSameDay
    });
  };
  PnmacMessage.prototype.renderDay = function () {
    if (this.props.currentMessage.createdAt) {
      var dayProps = this.getInnerComponentProps();
      if (this.props.renderDay) {
        return this.props.renderDay(dayProps);
      }
      return /*#__PURE__*/React.createElement(PnmacDay, __assign({}, dayProps));
    }
    return null;
  };
  PnmacMessage.prototype.renderBubble = function () {
    var bubbleProps = this.getInnerComponentProps();
    if (this.props.renderBubble) {
      return this.props.renderBubble(bubbleProps);
    }
    return /*#__PURE__*/React.createElement(PnmacBubble, __assign({}, bubbleProps));
  };
  PnmacMessage.prototype.renderAvatar = function () {
    if (this.props.user._id !== this.props.currentMessage.user._id) {
      var avatarProps = this.getInnerComponentProps();
      return /*#__PURE__*/React.createElement(PnmacAvatar, __assign({}, avatarProps));
    }
    return null;
  };
  PnmacMessage.prototype.render = function () {
    return /*#__PURE__*/React.createElement(View, {
      testID: "pnmacMsg"
    }, /*#__PURE__*/React.createElement(View, {
      style: [styles[this.props.position].container, {
        marginBottom: isSameUser(this.props.currentMessage, this.props.nextMessage) ? 2 : 10
      }, this.props.containerStyle[this.props.position], {
        alignItems: Platform.select({
          web: "left",
          ios: 'flex-start',
          android: 'flex-start'
        })
      }]
    }, this.props.position === "left" ? this.renderAvatar() : null, this.renderBubble(), this.props.position === "right" ? this.renderAvatar() : null));
  };
  return PnmacMessage;
}(React.PureComponent);
PnmacMessage.defaultProps = {
  renderAvatar: null,
  renderBubble: null,
  renderDay: null,
  position: "left",
  currentMessage: {},
  nextMessage: {},
  previousMessage: {},
  user: {},
  containerStyle: {}
};
PnmacMessage.propTypes = {
  renderAvatar: PropTypes.func,
  renderBubble: PropTypes.func,
  renderDay: PropTypes.func,
  position: PropTypes.oneOf(["left", "right"]),
  currentMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  user: PropTypes.object,
  containerStyle: PropTypes.shape({
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
    right: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
  })
};
export default PnmacMessage;